/**
 * Prefetch cache for admin user detail so PermissionRoute's permissions
 * round-trip can overlap with /api/admin/users/:id/.
 */
const inflight = new Map();
const settled = new Map();

export const prefetchAdminUserDetail = (token, userId, fetcher) => {
  const key = String(userId);
  if (settled.has(key) || inflight.has(key)) {
    return inflight.get(key) || Promise.resolve(settled.get(key));
  }
  const promise = Promise.resolve()
    .then(() => fetcher(token, userId))
    .then((result) => {
      settled.set(key, result);
      inflight.delete(key);
      return result;
    })
    .catch((error) => {
      inflight.delete(key);
      throw error;
    });
  inflight.set(key, promise);
  return promise;
};

export const takePrefetchedAdminUserDetail = (userId) => {
  const key = String(userId);
  if (settled.has(key)) {
    const value = settled.get(key);
    settled.delete(key);
    return Promise.resolve(value);
  }
  if (inflight.has(key)) {
    const promise = inflight.get(key);
    // Consumer owns the result; drop settled entry once resolved.
    return promise.then((value) => {
      settled.delete(key);
      return value;
    });
  }
  return null;
};

export const clearAdminUserDetailPrefetch = (userId = null) => {
  if (userId == null) {
    inflight.clear();
    settled.clear();
    return;
  }
  const key = String(userId);
  inflight.delete(key);
  settled.delete(key);
};
